<div class="page row" >
  <!-- Filtro sidebar -->
  <div class="col-lg-3" *ngIf="FilterViewType == 'sidebar' && openFilter"
    style="transition: 0.2s ease-in; background-color: white;">
    <div class="card">
      <div class="card-body">
        <h5 class="card-title">Filtri</h5>
        <app-field-viewer [(Campi)]="CrudSettings.Filters" [(Oggetto)]="filtro"
          (OnChange)="Refresh()"></app-field-viewer>
      </div>
    </div>
  </div>
  <!-- Container -->
  <div [ngClass]="!FilterViewType || FilterViewType == 'normal' || !openFilter ? 'col-12': 'col-lg-9'">
    <div class="d-flex align-items-center justify-content-between">
      <!-- Titolo + Tasto Filtro -->
      <div class="d-md-flex align-items-center  p-2">
        <div class="mt-3 mt-md-0">
          <div class="d-flex align-items-center ml-3 justify-content-start">
            <button type="button" *ngIf="FilterViewType == 'sidebar'" (click)="openFilter = !openFilter"
              class="btn p-2">
              <i class="fas fa-filter  mr-1 " style="font-size: 18px"
                [ngClass]="openFilter ? 'text-info': 'text-dark'"></i>
            </button>
            <span class="ml-1 text-dark" id="title" style="font-size: 25px; text-transform: uppercase; font-weight: 700;" *ngIf="!CrudSettings?.hasHeader && !CrudSettings.listView ">{{title
              ?? '' | translate}}</span>
              <ng-container *ngIf="CrudSettings?.badges?.length && CrudSettings?.listView == 'list'">
                <div class="ml-1" *ngFor="let badge of CrudSettings?.badges">
                  <span class="d-flex align-items-center p-2 " *ngIf="ListResponse[badge.field]">
                    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"> {{ badge.nome | translate}}:</h5>
                    <span class="badge badge-pill px-3 font-weight-bold font-14" [ngStyle]="{'background-color': badge.color}">{{ListResponse[badge.field]}}</span>
                  </span>
                </div>

              </ng-container>

          </div>
        </div>
      </div>
      <div class="d-md-flex align-items-center justify-content-end mb-3">
        <button type="button" *ngIf="HasAddButton()" (click)="AddClick()" class="btn btn-cyan p-2">
          <i class="fas fa-plus  font-14 mr-1 text-white"></i>
          <span class="ml-1 text-white font-weight-bold">Aggiungi</span>
        </button>
        <div ngbDropdown>
          <button  ngbDropdownToggle aria-haspopup="true" aria-expanded="false" type="button" *ngIf="CrudSettings && hasExportButtons()" class="btn btn-cyan p-2">
            <i class="fas fa-download  font-14 mr-1 text-white"></i>
            <span class="ml-1 text-white font-weight-bold">Esporta</span>
          </button>
          <div class="dropdown-menu-right " style=" padding-left: 20px; padding-right: 20px; width: 350px;" ngbDropdownMenu>
            <div class="row "   >
              <a class="dropdown-item" (click)="Export('xlsx')">
                <i class="fa fa-download m-r-5 m-l-5"></i>
                Excel
              </a>
            </div>
            <div class="row "   >
              <a class="dropdown-item" (click)="Export('csv')">
                <i class="fa fa-download m-r-5 m-l-5"></i>
                Csv
              </a>
            </div>
            <div *ngIf="CrudSettings?.FullExportExcel" class="row "   >
              <a class="dropdown-item" (click)="Export('xlsx', true)">
                <i class="fa fa-download m-r-5 m-l-5"></i>
                Excel Completo
              </a>
            </div>
            <div *ngIf="CrudSettings?.FullExportExcel" class="row "   >
              <a class="dropdown-item" (click)="Export('csv', true)">
                <i class="fa fa-download m-r-5 m-l-5"></i>
                Csv Completo
              </a>
            </div>
          </div>
        </div>


        <ng-container *ngFor="let button of CrudSettings['Buttons']">
          <button type="submit" type="button" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? ''"
                  *ngIf=" permission.HasCapacity(button['capacita']) && campoUtility.ButtonShow(button,this)"
                  (click)='customButton(button)'>
            <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
            <span [ngClass]="button['labelClass']"> {{ button['nome'] | translate }} </span>
          </button>
        </ng-container>
        <ng-container *ngIf="hasListActions()">
          <ng-container *ngFor="let button of CrudSettings['AzioniLista']">
            <button type="submit" type="button" [ngClass]="button['class']" [ngStyle]="button['style']" [ngbTooltip]="button.placeholder ?? button.tooltip ?? ''"
              *ngIf=" !button.single && campoUtility.ButtonShow(button,Item)" (click)='MassiveButtonClick(button)'>
              <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
              <ng-container *ngIf="button['svgIcon']" [innerHTML]="button['svgIcon']" ></ng-container>
              <span [ngClass]="button['labelClass']"> {{ button['nome'] | translate }} </span>
            </button>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Filtri normali -->
    <div class="card filter-card" *ngIf=" CrudSettings?.Filters?.length && (!FilterViewType || FilterViewType == 'normal') && CrudSettings.listView!= 'card' ">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-12">
            <app-field-viewer *ngIf="CrudSettings" [(Campi)]="CrudSettings.Filters" [(Oggetto)]="filtro"
              (OnChange)="Refresh()"></app-field-viewer>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf=" filtro && CrudSettings?.Filters?.length && (!FilterViewType || FilterViewType == 'normal') && CrudSettings.listView== 'card' ">
      <app-field-viewer *ngIf="CrudSettings" [(Campi)]="CrudSettings.Filters" [(Oggetto)]="filtro"
                              (OnChange)="Refresh()"></app-field-viewer>
    </div>

      <app-legenda *ngIf="CrudSettings?.Legenda" [legenda]="CrudSettings.Legenda"></app-legenda>
    <!-- Lista -->
    <div class="fav-header" *ngIf="CrudSettings?.hasHeader">
      <div>
        <h1 class="fav-title">{{CrudSettings.listTitle}}</h1>
        <p class="fav-sub" *ngIf="CrudSettings.listSubtitle">{{ListResponse?.total ?? 0}} {{CrudSettings?.listSubtitle ?? ''}}</p>
      </div>
      <div class="fav-view-toggle" *ngIf="CrudSettings.hasViewSwitch">
        <button class="fav-vbtn on" id="favGrid" (click)="CrudSettings.listView = 'card'">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7" rx="1"></rect><rect x="14" y="3" width="7" height="7" rx="1"></rect><rect x="3" y="14" width="7" height="7" rx="1"></rect><rect x="14" y="14" width="7" height="7" rx="1"></rect></svg>
        </button>
        <button class="fav-vbtn" id="favList" (click)="CrudSettings.listView = 'card-list'">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" viewBox="0 0 24 24"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
        </button>
      </div>
    </div>
    <div [ngTemplateOutlet]="ListaDefault" *ngIf="['list'].includes(CrudSettings?.listView ?? 'list')"></div>
    <div [ngTemplateOutlet]="CardList" *ngIf="['card'].includes(CrudSettings?.listView ?? 'list')"></div>
    <div [ngTemplateOutlet]="CardListList" *ngIf="['card-list'].includes(CrudSettings?.listView ?? 'list')"></div>
    <div class="d-flex justify-content-center mt-3" *ngIf="totalItems && (!this.CrudSettings?.ListDefaultFilter || this.CrudSettings?.ListDefaultFilter['page'] != 0)">
      <ngb-pagination
        [collectionSize]="totalItems"
        [(page)]="filtro.page"
        [pageSize]="filtro.size"
        (pageChange)="onPageChange($event)"
        [maxSize]="10"
      >
      </ngb-pagination>
    </div>
  </div>
</div>

<ng-template #ListaDefault>
  <div class="table-responsive">
    <table class="table table-striped table-hover table-fixed align-middle mb-0 " [ngClass]=" (CrudSettings.noWrap ? 'no-wrap ' : '') + (CrudSettings.listClass ?? '') ">
      <thead class="fi">
      <tr *ngIf="dynamicHeader()?.length > 0">
        <th *ngIf="hasListActions()">
          <a href="javascript:void(0)" class="link-header"
             (click)="toggleAll('selected', List)">{{allSelected('selected', List) ? 'Deseleziona tutto' :
            'Seleziona tutto'}}</a>
        </th>
        <ng-container *ngFor="let campo of dynamicHeader()">
          <th scope="col bg-white" (click)="order(campo)" *ngIf="headShow(campo)">{{campo.nome}}</th>
        </ng-container>
        <th scope="col" *ngIf="CrudSettings && (CrudSettings['AzioniLista']?.length || (!CrudSettings['DisableEdit'] && CrudSettings.campi))">{{!CrudSettings?.noActionLabel ? 'Azioni' : ''}}</th>
      </tr>
      </thead>
      <tbody *ngIf="dynamicHeader()?.length > 0 ">
      <tr *ngFor="let item of List " [ngbTooltip]="this.Tooltip(item)">
        <td *ngIf="hasListActions()">
          <input [(ngModel)]="item['selected']" type="checkbox" />
        </td>
        <ng-container *ngFor="let campo of dynamicHeader()">
          <td class="align-middle" [attr.data-label]="campo.nome" (click)='RowClick(item)' *ngIf="headShow(campo)">
            <app-dynamic-list-row (refresh)="Refresh()" [item]="item" [campo]="campo"></app-dynamic-list-row>
          </td>
        </ng-container>

        <td class="align-middle"  *ngIf="CrudSettings && (CrudSettings['AzioniLista']?.length || (!CrudSettings['DisableEdit'] && CrudSettings.campi))">
          <ng-container *ngIf="CrudSettings">
            <ng-container *ngFor="let button of CrudSettings['AzioniLista']">
              <a href="javascript:void(0)" [ngClass]="button['class']" [ngStyle]="button['style']"  [ngbTooltip]="button.placeholder ?? button.tooltip ?? ''"
                 *ngIf="campoUtility.ButtonShow(button,item)" (click)='ButtonClick(item, button)'>
                <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1"></i> <div *ngIf="button['svgIcon']" [innerHTML]="button['svgIcon']" ></div> {{button['iconLabel'] ?? ''}}
              </a>
            </ng-container>
          </ng-container>
          <a href="javascript:void(0)" *ngIf="CrudSettings && !CrudSettings['DisableEdit'] && CrudSettings.campi" [ngbTooltip]="'Modifica'" class="link font-16 text-info font-medium mr-2"
             (click)='EditButton(item)'>
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
          <app-stampa [Stampe]="Stampe(item)" [isIcon]="true" *ngIf="Stampe(item)?.length"></app-stampa>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</ng-template>



<ng-template #CardListList>
  <div class="list-container ">
    <div style="width: 100%">


      <div class="card-list-list " [ngClass]=" (CrudSettings.noWrap ? 'no-wrap ' : '') + (CrudSettings.listClass ?? '') " >

        <div class="card" [ngClass]="CrudSettings['cardClass'] ?? ''"  *ngFor="let item of List " [ngbTooltip]="this.Tooltip(item)" >
          <div class="card-body" >

            <div class="pc-img" *ngIf="CrudSettings['ImageUrl']">
              <img  [src]="CrudSettings['ImageUrl'](item, this)" (click)='RowClick(item)' [alt]="'      immagine non disponibile'">
              <ng-container *ngFor="let cardButton of CrudSettings['cardButtons'] ?? []">
                <button [ngClass]="cardButton['class']" (click)="cardButton.func(item, this)" *ngIf="campoUtility.ButtonShow(cardButton,item)"><div [innerHTML]="cardButton.content(item, this)"></div></button>
              </ng-container>
            </div>

            <div class="info-card">
              <ng-container *ngFor="let campo of dynamicHeader()">
                <div [attr.data-label]="campo.nome" (click)='RowClick(item)' *ngIf="headShow(campo)">
                  <app-dynamic-list-row (refresh)="Refresh()" [item]="item" [campo]="campo"></app-dynamic-list-row>
                </div>
              </ng-container>
            </div>
            <div class="buttons">
              <ng-container *ngIf="CrudSettings">
                <ng-container *ngFor="let button of CrudSettings['AzioniLista']">
                  <button class="card-button" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? button.tooltip ?? ''" *ngIf="campoUtility.ButtonShow(button,item)" (click)='ButtonClick(item, button)'>
                    <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1"></i>&nbsp;{{button.nome}}
                  </button>
                </ng-container>
              </ng-container>
            </div>

          </div>

        </div>
      </div>
    </div>

    <ng-container *ngIf="CrudSettings?.sidebarListSections?.length" [ngTemplateOutlet]="ShopAside">

    </ng-container>
  </div>
</ng-template>

<ng-template #CardList>
  <div class="list-container ">
    <div>
      <div class="cat-head d-flex align-items-center justify-content-between">

        <div class="cat-head-left">
          <ng-container *ngIf="CrudSettings?.badges?.length ">
            <div class="ml-1" *ngFor="let badge of CrudSettings?.badges">
        <span class="d-flex align-items-center p-2" *ngIf="ListResponse && ListResponse[badge.field]">
          <h5 class="mb-0 text-dark font-weight-bold font-14">
            {{ListResponse[badge.field]}}
          </h5>
          &nbsp;
          <span class="badge badge-pill px-3 font-weight-bold font-14"
                [ngStyle]="{'background-color': badge.color}">
            {{ badge.nome | translate}}
          </span>
        </span>
            </div>
          </ng-container>
        </div>

        <div class="order-filter-wrapper" *ngIf="CrudSettings?.Id === 'catalogo'">
          <app-field-viewer
            [(Campi)]="OrderFilters"
            [(Oggetto)]="filtro"
            (OnChange)="Refresh()">
          </app-field-viewer>
        </div>

      </div>

      <div class="card-list " [ngClass]=" (CrudSettings.noWrap ? 'no-wrap ' : '') + (CrudSettings.listClass ?? '') " [ngStyle]="CrudSettings['cardPerRow'] ? {'grid-template-columns': 'repeat('+CrudSettings['cardPerRow']+', 1fr)'}: null" >

        <div class="card" [ngClass]="CrudSettings['cardClass'] ?? ''"  *ngFor="let item of List " [ngbTooltip]="this.Tooltip(item)" >
          <div class="card-body">

            <div class="pc-img" *ngIf="CrudSettings['ImageUrl']">
              <img  [src]="CrudSettings['ImageUrl'](item, this)" (click)='RowClick(item)' [alt]="'      immagine non disponibile'">
              <ng-container *ngFor="let cardButton of CrudSettings['cardButtons'] ?? []">
                <button [ngClass]="cardButton['class']" (click)="cardButton.func(item, this)" *ngIf="campoUtility.ButtonShow(cardButton,item)"><div [innerHTML]="cardButton.content(item, this)"></div></button>
              </ng-container>
            </div>

            <div class="info-card">
              <ng-container *ngFor="let campo of dynamicHeader()">
                <div [attr.data-label]="campo.nome" (click)='RowClick(item)' *ngIf="headShow(campo)">
                  <app-dynamic-list-row (refresh)="Refresh()" [item]="item" [campo]="campo"></app-dynamic-list-row>
                </div>
              </ng-container>
            </div>
            <div class="buttons">
              <ng-container *ngIf="CrudSettings">
                <ng-container *ngFor="let button of CrudSettings['AzioniLista']">
                  <button class="card-button" [ngClass]="button['class']" [ngStyle]="button['style']" [ngbTooltip]="button.placeholder ?? button.tooltip ?? ''" *ngIf="campoUtility.ButtonShow(button,item)" (click)='ButtonClick(item, button)'>
                    <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1"></i>&nbsp;{{button.nome}}
                  </button>
                </ng-container>
              </ng-container>
            </div>

          </div>

        </div>
      </div>
    </div>

   <ng-container [ngTemplateOutlet]="ShopAside">

   </ng-container>
  </div>
</ng-template>


<ng-template #ShopAside>
  <aside id="shopSidebar" *ngIf="CrudSettings?.sidebarListSections?.length">

    <!-- Card negozio in evidenza (stile screenshot) -->
    <div class="ss-section" *ngFor="let section of CrudSettings?.sidebarListSections">
      <div class="ss-title">
        {{section.nome}}
        <span class="ss-arrow">›</span>
      </div>
      <ng-container *ngIf="ListResponse && ListResponse[section.campo] && section.type == 'card'">
        <div class="ss-sug-card" *ngFor="let item of ListResponse[section.campo]">
          <div class="ss-sug-img">🧥 👗 🧣</div>
          <div class="ss-sug-body">
            <ng-container *ngFor="let header of section.headers">
              <div [attr.data-label]="header.nome" *ngIf="headShow(header)" >
                <app-dynamic-list-row (refresh)="Refresh()" [item]="item" [campo]="header"></app-dynamic-list-row>
              </div>
            </ng-container>
            <ng-container *ngIf="CrudSettings && section">
              <ng-container *ngFor="let button of section['Azioni']">
                <button class="ss-sug-btn" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? button.tooltip ?? ''" *ngIf="campoUtility.ButtonShow(button,item)" (click)='ButtonClick(item, button)'>
                  <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1"></i>&nbsp;{{button.nome}}
                </button>
              </ng-container>
            </ng-container>
          </div>

        </div>
      </ng-container>

      <ng-container *ngIf="ListResponse && ListResponse[section.campo] && section.type == 'list'">
        <div class="ss-shops">
          <div class="ss-shop" *ngFor="let item of ListResponse[section.campo]">
            <div class="ss-shop-logo" style="background:#0ea5e9">FT</div>
            <div class="ss-shop-info">
              <ng-container *ngFor="let header of section.headers">
                <div [attr.data-label]="header.nome" *ngIf="headShow(header)" >
                  <app-dynamic-list-row (refresh)="Refresh()" [item]="item" [campo]="header"></app-dynamic-list-row>
                </div>
              </ng-container>
            </div>
            <ng-container *ngIf="CrudSettings && section">
              <ng-container *ngFor="let button of section['Azioni']">
                <button class="ss-shop-follow" [ngClass]="button['class']" [ngStyle]="button['style']" [ngbTooltip]="button.placeholder ?? button.tooltip ?? ''" *ngIf="campoUtility.ButtonShow(button,item)" (click)='ButtonClick(item, button)'>
                  <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1"></i>{{button.nome}}
                </button>
              </ng-container>
            </ng-container>

          </div>
        </div>
      </ng-container>
    </div>

  </aside>
</ng-template>
